import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, FormArray, UntypedFormBuilder, Validators, NgForm } from '@angular/forms';
import { Global } from 'src/app/Global';
import * as XLSX from 'xlsx';
import saveAs from 'file-saver';
import { DataService } from 'src/app/Common/data.service';
import { environment } from '../../../environments/environment';
import { HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
  selector: 'app-assignment-upload',
  templateUrl: './assignment-upload.component.html',
  styleUrls: ['./assignment-upload.component.scss'],
  providers: [DataService]
})
export class AssignmentUploadComponent implements OnInit {
  AssignmentUploadForm: UntypedFormGroup;
  uploadedFile: File;
  excelPath: string;
  ErrorMassage = [];
  isLoadingResults = false;
  formData: any;
  FileUpload: any;
  DataExportList: any;
  objAssignmentModel = new AssignmentModel();

  constructor(public _dataservice: DataService, private _fb: UntypedFormBuilder, public _global: Global, private _router: Router) { }

  ngOnInit() {
    this.AssignmentUploadForm = this._fb.group({
      //UploadID: [''],
      TemplateName: [''],
      FileName: [''],
      UploadedBy: [''],
      UploadedOn: [],
      PageNumber: (this._global.pageIndex),
      PageSize: (this._global.RecordSize),
    });

    this.excelPath = environment.serviceBaseUrl + '../Templates/AssignmentUploadFormat.xlsx';
  }




  onfilechange(event: any) {
    this.uploadedFile = event.target.files[0];
    if (!this.checkValueIsNullOrEmptyOrUndefined(this.uploadedFile)) {
      const fileExtenstion = this.uploadedFile.name.substring(this.uploadedFile.name.lastIndexOf('.') + 1);
      if (fileExtenstion != 'xls' && fileExtenstion != 'xlsx') {
        alert("Only file with extension .xls, .xlsx are allowed");
        event.target.value = "";
        return;
      }
    }
  }

  checkValueIsNullOrEmptyOrUndefined(value: any) {
    if (value == null || value == undefined || value == "") {
      return true;
    }
    else {
      return false;
    }
  }

  UploadAttachment(_event: any) {

    if (this.checkValueIsNullOrEmptyOrUndefined(this.uploadedFile)) {
      alert('Please choose file to upload.')
      return;
    }
    if (!confirm('Do you want to continue?')) {
      return;
    }
    debugger;
    this.ErrorMassage = [];
    if (this.uploadedFile["size"] > 0) {
      const maxLength = 1024 * 1024 * 10;
      const fileExtension = this.uploadedFile["name"].substring(this.uploadedFile["name"].lastIndexOf('.') + 1);;
      if (fileExtension.toLowerCase() === 'xls' || fileExtension.toLowerCase() === 'xlsx') {
        if (this.uploadedFile["size"] > maxLength) {
          alert('Filesize can not be more than 10 mb.');
          return;
        }
        this.InsertUploadTemplateDetails();
      } else {
        alert('Please upload only xls/xlsx file.');
      }
    } else {
      alert('Please upload  xls/xlsx file.');
    }
  }
  InsertUploadTemplateDetails() {
    this.saveuploadeddata();
  }
  saveuploadeddata() {
    debugger;
    this.isLoadingResults = true;
    this.formData = new FormData();
    this.formData.append('Filesupload', this.uploadedFile, this.uploadedFile["name"]);
    this._dataservice.PostData('Attachment/UploadAssignmentFromExcel/', this.formData).subscribe((data: {
      [x: string]: any;
      ResponseData: { Table: any; };
    }) => {
      debugger;
      if (data['StatusCode'] === 'ok') {
        alert(data['MessageContent']);
        this.formData = null;
        this.FileUpload = null;
        this.uploadedFile = null;

      } else if (data['StatusCode'] === 'Error' || data['StatusCode'] === 'ConversionError') {
        alert(data['MessageContent']);
        this.formData = null;
        this.FileUpload = null;
        this.uploadedFile = null;

      } else {
        alert('File uploaded with errors in some record. Please click Download to open the error file.');
        this.DataExportList = data.ResponseData.Table;
        this.formData = null;
        this.exportAsXLSX(this.DataExportList);
        this.FileUpload = null;
        this.uploadedFile = null;

      }
      this.isLoadingResults = false;
    },
      (_err: HttpErrorResponse) => {
        this._router.navigate(['/error/2']);
      });
  }

  exportAsXLSX(data: any): void {
    this.exportAsExcelFile(data, this.uploadedFile["name"]);

  }

  public exportAsExcelFile(json: any, excelFileName: string): void {
    const EXCEL_EXTENSION = '.xlsx';
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    console.log('worksheet', worksheet);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    XLSX.writeFile(workbook, excelFileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION, { bookType: 'xlsx', type: 'buffer' });
  }

  Exit() {

    if (this.AssignmentUploadForm.valid) {
      if (confirm("Are you sure you want to exit without saving changes?")) {
        //this.router.navigate(['dashboard']);
        window.history.back();
      }
    } else {
      if (confirm("Are you sure to exit?")) {
        //this.router.navigate(['dashboard']);
        window.history.back();
      }
    }

  }

  // SaveSalarySlipImport = () => {

  //   this.ErrorMassage = [];
  //   if (this.objAssignmentModel.AssignmentGroupName == null || this.objAssignmentModel.AssignmentGroupName === '') {
  //     this.ErrorMassage.push({ message: 'Please enter Asignment Group.' });
  //   }
  //   if (this.objAssignmentModel.EmpName == null || this.objAssignmentModel.EmpName === '') {
  //     this.ErrorMassage.push({ message: 'Please select is Employee Name.' });
  //   }
  //   if (this.objAssignmentModel.SRNumber == null || this.objAssignmentModel.SRNumber === '') {
  //     this.ErrorMassage.push({ message: 'Please select is SR Number.' });
  //   }
  //   if (this.ErrorMassage.length > 0) {
  //     return;
  //   }
  //     this.UploadAttachment1(this.uploadedFile);
  // }


  // UploadAttachment1(event) {
  //   this.DataExportList = null;
  //   if (event.target.files.length > 0) {
  //     const fileList: FileList = event.target.files;
  //     const file: File = fileList[0];
  //     const maxLength = 1024 * 1024 * 5;
  //     const fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1);
  //     if (fileExtension.toLowerCase() === 'xls' || fileExtension.toLowerCase() === 'xlsx') {
  //       if (event.target.files[0].size > maxLength) {
  //         alert('Filesize can not be more than 5 mb.');
  //         return;
  //       }
  //       this.formData = new FormData();
  //       this.formData.append('Filesupload', file, file.name);
  //       this.formData.append('AssignmentGroupName', this.objAssignmentModel.AssignmentGroupName.toString());
  //       this.formData.append('OriginalFileName', file.name);
  //       this.formData.append('EmpName', this.objAssignmentModel.EmpName);
  //       this.formData.append('SRNumber', this.objAssignmentModel.SRNumber);

  //         this._dataservice.PostData('Attachment/UploadAssignmentFromExcel/',this.formData).subscribe(data =>{
  //         if (data['StatusCode'] === 'ok') {

  //           alert(data['MessageContent']);
  //         } else if (data['StatusCode'] === 'Error') {
  //           alert(data['MessageContent']);
  //         } else {
  //           // this.DataExportList = data.ResponseData.Table;
  //           // this.exportAsXLSX(this.DataExportList);
  //         }
  //       },
  //         (err: HttpErrorResponse) => {
  //           // this._dataservice.GetRestItems('api/CommonFunction/LogError?httpException=' + err).subscribe(data => {
  //           // });
  //           // this._router.navigate(['/error/2']);
  //         });
  //     } else {
  //       alert('Please upload only xls/xlsx file.');
  //     }

  //   } else {
  //     alert('Please upload xls/xlsx file.');
  //   }

  // }

}

export class AssignmentModel {
  AssignmentGroupName: any;
  EmpName: string;
  uploadedFile: any;
  SRNumber: string;
}
